import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import qualificationService from "../service-api/qualificationService";

// Initial state
const initialState = {
  data: [],
  activeRoles: [],
  error: null,
  isLoading: true,
  isFormSubmitting: false,
};

export const fetchQualificationByCandidateID = createAsyncThunk(
  "data/fetchQualificationByCandidateID",
  async (id) => {
    const response = await qualificationService.fetchQualificationByCandidateID(
      id
    );
    return response.data;
  }
);

export const updateQualification = createAsyncThunk(
  "data/updateQualification",
  async ({ id, formData }) => {
    const response = await qualificationService.updateQualification(
      id,
      formData
    );
    return response.data;
  }
);

export const addQualification = createAsyncThunk(
  "data/addQualification",
  async (obj) => {
    const response = await qualificationService.addQualification(obj);
    return response.data;
  }
);

export const deleteQualification = createAsyncThunk(
  "data/deleteQualification",
  async (id) => {
    const response = await qualificationService.deleteQualification(id);
    return response.data;
  }
);

// Create slice
const qualificationSlice = createSlice({
  name: "role",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchQualificationByCandidateID.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchQualificationByCandidateID.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload.value;
      })
      .addCase(fetchQualificationByCandidateID.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });

    builder
      .addCase(updateQualification.pending, (state) => {
        state.isFormSubmitting = true;
      })
      .addCase(updateQualification.fulfilled, (state, action) => {
        state.isFormSubmitting = false;
      })
      .addCase(updateQualification.rejected, (state, action) => {
        state.isFormSubmitting = false;
        state.error = action.error.message;
      });

    builder
      .addCase(addQualification.pending, (state) => {
        state.isFormSubmitting = true;
      })
      .addCase(addQualification.fulfilled, (state, action) => {
        state.isFormSubmitting = false;
      })
      .addCase(addQualification.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });

    builder
      .addCase(deleteQualification.pending, (state) => {
        state.isFormSubmitting = true;
      })
      .addCase(deleteQualification.fulfilled, (state, action) => {
        state.isFormSubmitting = false;
      })
      .addCase(deleteQualification.rejected, (state, action) => {
        state.isFormSubmitting = false;
        state.error = action.error.message;
      });
  },
});

export default qualificationSlice.reducer;
